import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Collapse from "@material-ui/core/Collapse";
import A_IconButton from "../../../../Atoms/Inputs/Buttons/A_IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TuneIcon from "@material-ui/icons/Tune";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import { LayoutMenusStructure } from "./LayoutMenu";
import { useParams } from "react-router";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ClientLogoComponent from "./clientLogo";
import { useDispatch } from "react-redux";
import { getCurrentEventValue } from "../../../../../../store/actions/getEventValueAction";
import A_SimpleDialog from "../../../../Atoms/Feedback/Dialogs/A_SimpleDialog";
import A_Button from "../../../../Atoms/Inputs/Buttons/A_Button";
import M_Preferences from "../M_Preferences/M_Preferences";
import { getCRMContactInfo } from "../../../../../../Utils/Helpers/common";
import M_MenuIcon, { hasMenuIcon } from "./M_MenuIcon";
import Tooltip from "@material-ui/core/Tooltip";

const PREFERENCES_MENU_LABEL = "Preferences";
const PREFERENCES_DIALOG_TITLE = "Preferences";

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "var(--app-font-family, Arial, Helvetica, sans-serif)",
    "& *": {
      fontFamily: "inherit",
    },
    position: "relative",
    isolation: "isolate",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: 360,
    height: "100%",
    boxSizing: "border-box",
    borderRadius: 0,
    backgroundColor: "var(--color-background-paper)",
    boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.35)",
    color: "var(--color-text-primary)",
    overflow: "hidden",
    transition:
      "background-color 0.4s ease, color 0.4s ease, border-color 0.4s ease",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      zIndex: 2,
      background:
        "linear-gradient(90deg, var(--color-primary-main), transparent 72%)",
      opacity: 0.85,
    },
  },
  scrollArea: {
    position: "relative",
    zIndex: 1,
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    padding: theme.spacing(1.5, 1.25),
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0,
      display: "none",
    },
  },
  header: {
    position: "relative",
    zIndex: 1,
    flexShrink: 0,
    // No paddingTop — all vertical offset lives in pagesidebarClosebutton.marginTop
    // so both compact and expanded modes stay pixel-perfect aligned.
    "&::after": {
      content: '""',
      display: "block",
      height: 2,
      borderRadius: 999,
      background:
        "linear-gradient(90deg, var(--color-primary-main) 0%, var(--total_row_boldbackground) 35%, var(--total_row_boldbackground) 100%)",
      opacity: 0.9,
      marginTop: theme.spacing(0.75),
      marginLeft: theme.spacing(1.75),
      marginRight: theme.spacing(1.75),
    },
  },
  footer: {
    position: "relative",
    zIndex: 1,
    flexShrink: 0,
    padding: theme.spacing(0.75, 1.25, 1.25),
    borderTop: "1px solid var(--total_row_boldbackground)",
    boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.45)",
    backgroundColor: "var(--color-background-paper)",
    backdropFilter: "blur(16px) saturate(160%)",
    WebkitBackdropFilter: "blur(16px) saturate(160%)",
    backgroundImage:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, transparent 55%)",
  },
  themeFooterItem: {
    width: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(1, 1.15),
    borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    border: "1px solid transparent",
    backgroundColor: "transparent",
    color: "var(--color-text-primary)",
    cursor: "pointer",
    transition:
      "background-color 180ms ease, color 180ms ease, border-color 180ms ease, transform 160ms ease",
    "& .MuiListItemIcon-root": {
      minWidth: 32,
      color: "var(--color-text-secondary)",
      transition: "color 180ms ease",
    },
    "& .MuiListItemText-root": {
      margin: 0,
    },
    "&:hover, &:focus-visible, &.Mui-focusVisible": {
      backgroundColor: "var(--total_row_background)",
      borderColor: "var(--total_row_boldbackground)",
      color: "var(--color-primary-text)",
      transform: "translateX(2px)",
      outline: "none",
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-text)",
      },
    },
    "&:focus-visible, &.Mui-focusVisible": {
      boxShadow:
        "0 0 0 2px color-mix(in srgb, var(--color-primary-main) 55%, transparent)",
    },
  },
  themeFooterText: {
    fontSize: "0.84375rem",
    fontWeight: 600,
    letterSpacing: 0.1,
  },
  pagesidebarClosebutton: {
    padding: theme.spacing(0.5, 0.75),
    boxSizing: "border-box",
    justifyContent: "center",
    width: "100%",
    // 64px = height of the top navbar — keeps the logo fully
    // below the navbar in both expanded and compact (rail) modes.
    [theme.breakpoints.up("sm")]: {
      marginTop: "64px",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "7%",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: "12%",
      right: "12%",
      bottom: theme.spacing(-1.25),
      height: 1,
    },
  },
  pagesidebarClosebuttonone: {
    visibility: "hidden",
  },
  sectionWrap: {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    "&:not(:last-child)": {
      marginBottom: theme.spacing(1.5),
    },
  },
  sectionDivider: {
    height: 2,
    borderRadius: 999,
    background:
      "linear-gradient(90deg, var(--color-primary-main) 0%, var(--total_row_boldbackground) 35%, var(--total_row_boldbackground) 100%)",
    marginBottom: theme.spacing(0.75),
    opacity: 0.9,
    maxHeight: 4,
    overflow: "hidden",
    transition:
      "max-height 240ms cubic-bezier(0.4, 0, 0.2, 1), opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), margin 240ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  layoutGroup: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    fontSize: "0.6875rem",
    fontWeight: 800,
    letterSpacing: 1.4,
    textTransform: "uppercase",
    color: "var(--color-primary-text)",
    padding: theme.spacing(0.1, 0.35, 0.25),
    "&::before": {
      content: '""',
      width: 5,
      height: 5,
      borderRadius: "50%",
      background: "var(--color-primary-main)",
      boxShadow: "0 0 0 3px rgba(128, 128, 128, 0.12)",
      flexShrink: 0,
    },
  },
  layoutlist: {
    width: "100%",
    boxSizing: "border-box",
    marginTop: theme.spacing(0.35),
    borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    transition:
      "background-color 180ms ease, border-color 180ms ease, color 180ms ease, box-shadow 180ms ease, transform 160ms ease",
    overflow: "hidden",
  },
  sectionLabelItem: {
    width: "100%",
    padding: 0,
    marginTop: theme.spacing(0.4),
    marginBottom: theme.spacing(0.4),
    maxHeight: 48,
    overflow: "hidden",
    transition:
      "max-height 240ms cubic-bezier(0.4, 0, 0.2, 1), opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), margin 240ms cubic-bezier(0.4, 0, 0.2, 1), padding 240ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  sectionLabelText: {
    margin: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  sectionLabelButton: {
    cursor: "pointer",
    borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    transition: "background-color 180ms ease",
    "&:hover, &:focus-visible, &.Mui-focusVisible": {
      backgroundColor: "var(--total_row_background)",
      outline: "none",
    },
    "&:focus-visible, &.Mui-focusVisible": {
      boxShadow:
        "0 0 0 2px color-mix(in srgb, var(--color-primary-main) 55%, transparent)",
    },
  },
  sectionChevron: {
    marginLeft: "auto",
    marginRight: theme.spacing(1),
    fontSize: "1.125rem",
    color: "var(--color-primary-text)",
    flexShrink: 0,
    transition: "transform 240ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  sectionChevronCollapsed: {
    transform: "rotate(-90deg)",
  },
  clickableBtns: {
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    marginBottom: theme.spacing(0.6),
    padding: theme.spacing(1.05, 1.15, 1.05, 1.6),
    borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    border: "1px solid transparent",
    backgroundColor: "transparent",
    color: "var(--color-text-primary)",
    cursor: "pointer",
    transition:
      "padding 240ms cubic-bezier(0.4, 0, 0.2, 1), background-color 180ms ease, border-color 180ms ease, color 180ms ease",
    "& .MuiListItemText-root": {
      margin: 0,
      maxWidth: 200,
      overflow: "hidden",
      transition:
        "opacity 220ms cubic-bezier(0.4, 0, 0.2, 1), max-width 240ms cubic-bezier(0.4, 0, 0.2, 1)",
    },
    "& .MuiListItemText-primary": {
      fontSize: "0.84375rem",
      fontWeight: 600,
      lineHeight: 1.35,
      letterSpacing: 0.1,
    },
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: "50%",
      width: 3,
      height: 0,
      transform: "translateY(-50%)",
      borderRadius: 999,
      background: "var(--color-primary-main)",
      transition: "height 180ms ease",
    },
    "&:hover, &:focus-visible, &.Mui-focusVisible": {
      backgroundColor: "var(--total_row_background)",
      borderColor: "var(--total_row_boldbackground)",
      color: "var(--color-primary-text)",
      outline: "none",
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-text)",
        transform: "scale(1.1)",
      },
    },
    "&:hover::before, &:focus-visible::before, &.Mui-focusVisible::before": {
      height: "58%",
    },
    "&:focus-visible, &.Mui-focusVisible": {
      boxShadow:
        "0 0 0 2px color-mix(in srgb, var(--color-primary-main) 55%, transparent)",
    },
    "& .MuiListItemIcon-root": {
      minWidth: 32,
      color: "var(--color-text-secondary)",
      transition: "all 180ms ease",
    },
  },
  active: {
    transition:
      "background 240ms cubic-bezier(0.4, 0, 0.2, 1), background-image 240ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 240ms cubic-bezier(0.4, 0, 0.2, 1), transform 240ms cubic-bezier(0.4, 0, 0.2, 1), border-color 240ms cubic-bezier(0.4, 0, 0.2, 1)",
    color: "var(--color-primary-contrast)",
    background: "var(--color-primary-main)",
    backgroundImage:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0) 55%)",
    borderColor: "transparent",
    boxShadow:
      "0 6px 18px rgba(0, 0, 0, 0.22), inset 0 0 0 1px rgba(255, 255, 255, 0.08)",
    transform: "translateX(2px)",
    "& .MuiListItemText-primary": {
      fontWeight: 700,
    },
    "&::before": {
      height: "68%",
      background: "var(--color-primary-contrast)",
      opacity: 0.9,
    },
    "& .MuiListItemIcon-root": {
      color: "var(--color-primary-contrast) !important",
      filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.25))",
      opacity: 1,
      transform: "scale(1.05)",
    },
    "&:hover": {
      background: "var(--color-primary-main)",
      backgroundImage:
        "linear-gradient(135deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0) 55%)",
      borderColor: "transparent",
      color: "var(--color-primary-contrast)",
      filter: "brightness(1.06)",
      transform: "translateX(2px)",
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-contrast) !important",
      },
    },
    "&:hover::before": {
      height: "68%",
    },
  },
  footerDivider: {
    marginTop: theme.spacing(0.75),
    backgroundColor: "var(--total_row_boldbackground)",
  },
  emptyState: {
    padding: theme.spacing(2, 1),
    color: "var(--color-text-secondary)",
    fontSize: "0.8125rem",
  },
  noIconItem: {
    paddingLeft: `${theme.spacing(1)}px !important`,
  },
  compactMode: {
    "& $pagesidebarClosebutton": {
      padding: theme.spacing(1, 0),
    },
    "& $header::after": {
      marginLeft: `${theme.spacing(0.75)}px !important`,
      marginRight: `${theme.spacing(0.75)}px !important`,
    },
    "& .MuiListItemText-root": {
      opacity: 0,
      maxWidth: "0 !important",
      margin: "0 !important",
      padding: "0 !important",
      pointerEvents: "none",
    },
    "& $sectionLabelItem": {
      maxHeight: "26px !important",
      opacity: "1 !important",
      marginTop: `${theme.spacing(1)}px !important`,
      marginBottom: `${theme.spacing(0.25)}px !important`,
      justifyContent: "center !important",
      padding: "0 !important",
      cursor: "default !important",
      "& .MuiListItemText-root": {
        opacity: "1 !important",
        maxWidth: "none !important",
        margin: "0 !important",
        padding: "0 !important",
        display: "flex !important",
        justifyContent: "center !important",
      },
      "& $layoutGroup": {
        justifyContent: "center !important",
        fontSize: "0.75rem !important",
        fontWeight: "900 !important",
        letterSpacing: "0.5px !important",
        color: "var(--color-primary-text) !important",
        "&::before": {
          display: "none !important",
        },
      },
    },
    "& $sectionDivider": {
      maxHeight: "2px !important",
      opacity: "0.85 !important",
      marginTop: `${theme.spacing(0.5)}px !important`,
      marginBottom: `${theme.spacing(0.5)}px !important`,
    },
    // Let the circle's outer ring shadow bleed outside the tile boundary.
    "& $layoutlist": {
      overflow: "visible !important",
    },
    "& $clickableBtns": {
      height: "38px !important",
      padding: "0 !important",
      marginBottom: "1px !important",
      overflow: "visible !important",
      justifyContent: "center !important",
      alignItems: "center !important",
      "& .MuiListItemIcon-root": {
        minWidth: "0 !important",
        margin: "0 !important",
        justifyContent: "center !important",
        alignItems: "center !important",
      },
    },
    "& $themeFooterItem": {
      height: "38px !important",
      padding: "0 !important",
      justifyContent: "center !important",
      alignItems: "center !important",
      "& .MuiListItemIcon-root": {
        minWidth: "0 !important",
        margin: "0 !important",
        justifyContent: "center !important",
        alignItems: "center !important",
      },
    },
    "& $noIconItem": {
      paddingLeft: "0 !important",
    },
    "& $scrollArea": {
      paddingLeft: "0 !important",
      paddingRight: "0 !important",
      paddingTop: "4px !important",
    },
    "& $sectionWrap": {
      paddingLeft: "0 !important",
      paddingRight: "0 !important",
      "&:not(:last-child)": {
        marginBottom: `${theme.spacing(1.25)}px !important`,
      },
    },
    "& $active": {
      background: "transparent !important",
      backgroundImage: "none !important",
      boxShadow: "none !important",
      borderColor: "transparent !important",
      transform: "none !important",
      filter: "none !important",
      "&:hover": {
        background: "transparent !important",
        backgroundImage: "none !important",
        transform: "none !important",
        filter: "none !important",
      },
      "&::before": {
        display: "none !important",
      },
      "&:hover::before": {
        display: "none !important",
      },
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-text) !important",
        transform: "none !important",
        filter: "none !important",
        width: "38px !important",
        height: "38px !important",
        minWidth: "38px !important",
        borderRadius: "50% !important",
        background:
          "color-mix(in srgb, var(--color-primary-main) 16%, transparent) !important",
        boxShadow:
          "0 0 0 2px color-mix(in srgb, var(--color-primary-main) 55%, transparent) !important",
        display: "inline-flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
      },
    },
  },
}));

const getInitials = (str) => {
  if (!str) return "";
  return str
    .split(/\s+/)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
};

const M_LayoutMenu = React.memo((props) => {
  const classes = useStyles();
  const { isRailMode = false } = props;
  const isCompact = Boolean(isRailMode);
  const [layouts, setlayouts] = useState(LayoutMenusStructure(props.layouts));

  const [layoutsmenus, setLayoutsmenus] = useState([]);
  let { crmId } = useParams();
  const [currentuser, setCurrentuser] = React.useState("");
  const [menuItem, setMenuItem] = useState("");
  const [isMsgOpen, setIsMsgOpen] = useState(false);
  const [openPreferencesDialog, setOpenPreferencesDialog] = useState(false);
  const [collapsedSections, setCollapsedSections] = useState({});
  const eventValue = useSelector((state) => state.getEventValueStore);
  const dispatch = useDispatch();
  const _userid = useSelector((state) =>
    state?.getLoggedInUserReducer?.data?.[0]?.id
      ? state.getLoggedInUserReducer.data[0].id
      : ""
  );
  const { isUserSuperAdmin } = getCRMContactInfo();
  const UserPageProfile = crmId == currentuser;
  let loggedInUserDetail = JSON.parse(localStorage.getItem("contact_crm"));
  const userid =
    loggedInUserDetail && loggedInUserDetail.id
      ? loggedInUserDetail.id
      : _userid;

  const searchtext = "";
  useEffect(() => {
    setCurrentuser(userid);
  }, [userid]);

  useEffect(() => {
    setlayouts(LayoutMenusStructure(props.layouts));
  }, [props.layouts]);
  let clientName =
    window.location &&
      window.location.hostname &&
      window.location.hostname.split(".") &&
      window.location.hostname.split(".").length > 0
      ? window.location.hostname.split(".")[0]
      : "";

  React.useEffect(() => {
    const results = layouts.filter((layout) => {
      if (
        layout &&
        layout.name &&
        layout.name.toLowerCase().includes(searchtext)
      ) {
        return true;
      } else if (layout && layout.children && layout.children.length > 0) {
        let res = layout.children.filter((child) =>
          child.name.toLowerCase().includes(searchtext)
        );
        if (res && res.length > 0) {
          return true;
        }
      }
    });
    setLayoutsmenus(results);
    return function cleanup() {
      setLayoutsmenus([]);
    };
  }, [searchtext, layouts]);

  const parsedData = (data) => {
    try {
      if (typeof data === "string") {
        return JSON.parse(data);
      }
      return data;
    } catch {
      return data;
    }
  }

  function templateVisibility(templateConfig) {
    try {
      templateConfig = parsedData(templateConfig);
      // isPrivate condition
      if (templateConfig.isPrivate) {
        if (UserPageProfile) {
          return true;
        } else {
          return false
        }
      }
      // isSuperAdminTemplate condition
      if (templateConfig.isSuperAdminTemplate) {
        if (isUserSuperAdmin) {
          return true
        } else {
          return false
        }
      }

      return true;
    } catch (e) {
      return true;
    }
  }
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (eventValue) {
        const confirmationMessage = "You have unsaved changes. Do you really want to leave?";
        event.preventDefault();
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    };
    const handleUnload = () => {
      if (eventValue) {
        dispatch(getCurrentEventValue(false));
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, [eventValue]);
  let handleCancelPopup = () => {
    setIsMsgOpen(false);

  }
  let handleLeavePopup = () => {
    setIsMsgOpen(false);
    props.callback(menuItem);
    dispatch(getCurrentEventValue(false));
  }

  let handleMsgPopup = () => {
    setIsMsgOpen(false);
  };
  const openPreferences = () => setOpenPreferencesDialog(true);
  const closePreferences = () => setOpenPreferencesDialog(false);
  const getPublishActionItems = () => {
    return (
      <>
        <A_Button
          color="primary"
          label="Leave"
          autoFocus
          onClick={handleLeavePopup}
        />
        <A_Button
          color="default"
          label="Cancel"
          onClick={handleCancelPopup}
        />
      </>
    );
  };
  const toggleSection = (key) => {
    setCollapsedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleClick = (e, item) => {
    if (eventValue) {
      setMenuItem(item);
      setIsMsgOpen(true)
      return;
    }
    props.callback(item);
  };

  const inMenuHiddenTemplates = (templates) => {
    let toShowTemplates = templates.filter(
      (item) => {
        let parsedTemplateJson = item?.templateJson;
        if (typeof parsedTemplateJson == "string") {
          parsedTemplateJson = JSON.parse(parsedTemplateJson);
        }
        return !parsedTemplateJson?.show?.inMenuHidden;
      }
    );
    return toShowTemplates;
  };

  return (
    <>
      <div
        className={`${classes.root} ${isCompact ? classes.compactMode : ""}`}
      >
        <div className={classes.header}>
          <ListItem
            button
            component="div"
            className={classes.pagesidebarClosebuttonone}
            id="sidebarclosebutton"
          >
            <A_IconButton
              size="small"
              icon={<CloseIcon />}
              onClick={() => props.callback()}
            ></A_IconButton>
          </ListItem>

          <ListItem
            component="div"
            className={classes.pagesidebarClosebutton}
          >
            <ClientLogoComponent clientName={clientName} compact={isCompact} />
          </ListItem>
        </div>
        <List
          component="nav"
          disablePadding
          aria-label="layout side menu"
          className={classes.scrollArea}
        >
        {layoutsmenus && layoutsmenus.length > 0
          ? layoutsmenus
            .sort(function (a, b) {
              return a.sortOrder - b.sortOrder;
            })
            .map((item, index) => {
              const sectionKey = item?.name || `section_${index}`;
              const isSectionCollapsed =
                !isCompact && Boolean(collapsedSections[sectionKey]);
              const childItems = (
                <>
                  {inMenuHiddenTemplates(item.children || [])
                    .sort((a, b) => a.itemSortIndex - b.itemSortIndex)
                    .map((childItem, ind) => {
                      const listItemContent = (
                        <ListItem
                          button
                          onClick={(e) => handleClick(e, childItem)}
                          className={`${classes.layoutlist} ${classes.clickableBtns} ${childItem.id === props.currentPageId ? classes.active : ""} ${!hasMenuIcon(childItem.name) && !isCompact ? classes.noIconItem : ""}`}
                        >
                          {(hasMenuIcon(childItem.name) || isCompact) && (
                            <ListItemIcon>
                              <M_MenuIcon
                                name={childItem.name}
                                compact={isCompact}
                              />
                            </ListItemIcon>
                          )}
                          <ListItemText primary={childItem.name} />
                        </ListItem>
                      );

                      return (
                        templateVisibility(childItem.templateJson) && (
                          isCompact ? (
                            <Tooltip
                              key={`${childItem.id}_${ind}`}
                              title={childItem.name}
                              placement="right"
                              arrow
                            >
                              {listItemContent}
                            </Tooltip>
                          ) : (
                            React.cloneElement(listItemContent, { key: `${childItem.id}_${ind}` })
                          )
                        )
                      );
                    })}
                </>
              );

              return (
                <div
                  key={`fragment_${item.name}_${index}`}
                  className={classes.sectionWrap}
                >
                  {item && item.name ? (
                    <>
                      {index > 0 && (
                        <div className={classes.sectionDivider}></div>
                      )}
                      {isCompact ? (
                        <Tooltip
                          key={`${item.id}_${index}`}
                          title={item.name}
                          placement="right"
                          arrow
                        >
                          <ListItem
                            component="div"
                            className={`${classes.layoutlist} ${classes.sectionLabelItem}`}
                          >
                            <ListItemText
                              className={classes.sectionLabelText}
                              primary={
                                <Typography className={classes.layoutGroup}>
                                  {getInitials(item.name)}
                                </Typography>
                              }
                            />
                          </ListItem>
                        </Tooltip>
                      ) : (
                        <ListItem
                          key={`${item.id}_${index}`}
                          button
                          component="div"
                          onClick={() => toggleSection(sectionKey)}
                          aria-expanded={!isSectionCollapsed}
                          className={`${classes.layoutlist} ${classes.sectionLabelItem} ${classes.sectionLabelButton}`}
                        >
                          <ListItemText
                            className={classes.sectionLabelText}
                            primary={
                              <Typography className={classes.layoutGroup}>
                                {item.name}
                              </Typography>
                            }
                          />
                          <ExpandMoreIcon
                            className={`${classes.sectionChevron} ${isSectionCollapsed ? classes.sectionChevronCollapsed : ""}`}
                          />
                        </ListItem>
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {item && item.children && item.children.length > 0 ? (
                    isCompact ? (
                      childItems
                    ) : (
                      <Collapse in={!isSectionCollapsed} timeout="auto">
                        {childItems}
                      </Collapse>
                    )
                  ) : (
                    ""
                  )}

                </div>
              );
            })
          : ""}
        </List>
        <div className={classes.footer}>
          {isCompact ? (
            <Tooltip title={PREFERENCES_MENU_LABEL} placement="right" arrow>
              <ListItem
                button
                component="div"
                onClick={openPreferences}
                className={classes.themeFooterItem}
                aria-label="Open preferences"
              >
                <ListItemIcon>
                  <TuneIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={PREFERENCES_MENU_LABEL}
                  classes={{ primary: classes.themeFooterText }}
                />
              </ListItem>
            </Tooltip>
          ) : (
            <ListItem
              button
              component="div"
              onClick={openPreferences}
              className={classes.themeFooterItem}
              aria-label="Open preferences"
            >
              <ListItemIcon>
                <TuneIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={PREFERENCES_MENU_LABEL}
                classes={{ primary: classes.themeFooterText }}
              />
            </ListItem>
          )}
        </div>
      </div>
      <A_SimpleDialog
        open={openPreferencesDialog}
        title={PREFERENCES_DIALOG_TITLE}
        fullWidth={true}
        maxWidth={"md"}
        onClose={closePreferences}
        dialogContent={<M_Preferences />}
      />
      <A_SimpleDialog
        open={isMsgOpen}
        dialogContent=""
        closePopUp={handleMsgPopup}
        title="You have unsaved changes in the template. You can leave the page to discard the changes or cancel to continue editing and save all updates."
        dialogActions={getPublishActionItems()}
        onClose={handleMsgPopup}
      />
    </>
  );
});
M_LayoutMenu.displayName = "M_LayoutMenu";
M_LayoutMenu.propTypes = {
  callback: PropTypes.func,
  layouts: PropTypes.array,
  getLoggedInUser: PropTypes.func,
  loggedinUser: PropTypes.func,
  loggedIn: PropTypes.array,
  currentPageId: PropTypes.string,
  isRailMode: PropTypes.bool,
};
export default M_LayoutMenu;
